import { Check } from "lucide-react";

const STATES = [
  { label: "Proposé", done: true },
  { label: "Accepté", done: true },
  { label: "2 sur 3 terminées", done: false },
];

/** Short static example shown from the parent welcome ("Voir un exemple"). */
const PlanExampleCard = ({ time, mobileType = false }) => {
  const text = mobileType ? "text-[15px]" : "text-[13px]";
  return (
    <div className="max-w-[85%] self-start rounded-2xl rounded-tl-sm bg-white p-3 shadow-sm" data-testid="plan-example-card">
      <p className={`text-right text-[#A9B8AF] ${mobileType ? "text-[12px]" : "text-[10px]"}`} data-testid="plan-example-number">Plan d’étude #1</p>
      <p className="text-[10px] font-bold uppercase tracking-wider text-[#829C8D]">Exemple</p>
      <p className={`mt-1 font-semibold text-[#122118] ${text}`}>Exercices sur les fractions</p>
      <p className={`text-[#4a5f53] ${mobileType ? "text-[14px]" : "text-[12px]"}`}>3 séances de 20 minutes avant dimanche</p>
      <ol className="mt-3 flex flex-wrap items-center gap-1.5">
        {STATES.map((state, index) => (
          <li key={state.label} className="flex items-center gap-1.5">
            <span
              className={`inline-flex items-center gap-1 rounded-full px-2.5 py-1 text-[11px] font-bold ${
                state.done ? "bg-[#E9FBF0] text-[#128a3e]" : "bg-[#FFF8E1] text-[#8a6500]"
              }`}
            >
              {state.done && <Check className="h-3 w-3" />}
              {state.label}
            </span>
            {index < STATES.length - 1 && <span className="text-[#829C8D]">→</span>}
          </li>
        ))}
      </ol>
      <div className="mt-3 h-1.5 w-full overflow-hidden rounded-full bg-[#EEF5F1]">
        <div className="h-full w-2/3 rounded-full bg-[#25D366]" />
      </div>
      <div className="mt-1 text-right text-[10px] text-gray-500">{time}</div>
    </div>
  );
};

export default PlanExampleCard;
